// src/pages/charts/MediaControls.jsx (경로는 기존 그대로)
import styles from '../Simulation.module.css';

const MAX_TIME = 600; // seconds

function pad2(n) {
    return String(n).padStart(2, '0');
}
function secondsToMMSS(sec) {
    const m = Math.floor(sec / 60);
    const s = Math.floor(sec % 60);
    return `${pad2(m)}:${pad2(s)}`;
}

export default function MediaControls({ time, setTime, isPlaying, setIsPlaying, speed, setSpeed, max = MAX_TIME, simulationId, send }) {
    const onPrev10 = () => {
        send({ action: 'seek_delta', simulationId, seconds: -10 });
        setTime((t) => Math.max(0, t - 10));
    };
    const onNext10 = () => {
        send({ action: 'seek_delta', simulationId, seconds: 10 });
        setTime((t) => Math.min(max, t + 10));
    };
    const onStop = () => {
        send({ action: 'stop', simulationId });
        setIsPlaying(false);
        setTime(0);
    };
    const onPlayPause = () => {
        const next = !isPlaying;
        setIsPlaying(next);
        send({ action: 'set_playing', simulationId, playing: next });
    };

    const onSeek = (sec) => {
        setTime(sec);
        send({ action: 'seek_to', simulationId, seconds: sec });
    };

    return (
        <div className={styles.media}>
            <div className={styles.mediaRow}>
                {/* 🔹 첫 줄: seek bar + 시간 */}
                <div className={styles.mediaSeekRow}>
                    <input className={styles.mediaRange} type="range" min={0} max={max} step={1} value={Math.floor(time)} onChange={(e) => onSeek(Number(e.target.value))} />
                    <div className={styles.mediaTime}>
                        {secondsToMMSS(time)} / {secondsToMMSS(max)}
                    </div>
                </div>

                {/* 🔹 둘째 줄: 컨트롤 버튼 + 배속 */}
                <div className={styles.mediaControlRow}>
                    <button className={`${styles.btn} ${styles.btnIcon}`} onClick={onPrev10} title="이전(–10s)">
                        ⏮
                    </button>

                    <button className={`${styles.btn} ${styles.btnIcon} ${styles.btnPrimary}`} onClick={onPlayPause} title={isPlaying ? '일시정지' : '재생'}>
                        {isPlaying ? '⏸' : '▶'}
                    </button>

                    <button className={`${styles.btn} ${styles.btnIcon}`} onClick={onStop} title="정지">
                        ■
                    </button>

                    <button className={`${styles.btn} ${styles.btnIcon}`} onClick={onNext10} title="다음(+10s)">
                        ⏭
                    </button>

                    <div className={styles.mediaSpeed}>
                        <select className={`${styles.select} ${styles.selectXs}`} value={speed} onChange={(e) => setSpeed(Number(e.target.value))} title="배속">
                            {[1, 2, 3, 5, 10].map((v) => (
                                <option key={v} value={v}>
                                    {v}x
                                </option>
                            ))}
                        </select>
                    </div>
                </div>
            </div>
        </div>
    );
}
